export default {
  client: "CLIENT",
  name: "NAME",
  quote: "QUOTE",
  invoice: "INVOICE",
  date: "DATE",
  download_invoice: "Download Invoice",
  send_notification: "Send Notification",
  trip_programme: "TRIP PROGRAMME",
  pax: "Pax",
  total_program: "Total program",
  total_deposit: "TOTAL DEPOSIT",
  payment_method: "PAYMENT METHOD",
  bank_transfer: "BANK TRANSFER",
  bank_name: "BANK NAME",
  iban: "IBAN",
  swift_bic: "SWIFT/BIC",
  address: "ADDRESS",
  concept: "CONCEPT",
  trip_details: {
    case_name: "CASE NAME",
    destination: "DESTINATION",
    accommodation: "ACCOMMODATION",
    transfer: "TRANSFER",
    ebike: "EBIKE",
    luggage_transfer: "LUGGAGE TRANSFER",
    date: "DATE"
  }
};